import { createRouter, createWebHashHistory } from 'vue-router';
import OfficialView from '@/views/OfficialView.vue';
import GoodiesView from '@/views/GoodiesView.vue';
import DemosView from '@/views/DemosView.vue';
import VirtualSkipperView from '@/views/VirtualSkipperView.vue';
import GalleryView from '@/views/GalleryView.vue';
import FriendCollectionView from '@/views/FriendCollectionView.vue';

const routes = [
	{
		path: '/:country?',
		name: 'home',
		component: OfficialView,
	},
	{
		path: '/goodies/:type?',
		name: 'goodies',
		component: GoodiesView,
	},
	{
		path: '/demos/:country?',
		name: 'demos',
		component: DemosView,
	},
	{
		path: '/virtual-skipper/:version?',
		name: 'virtualskipper',
		component: VirtualSkipperView,
	},
	{
		path: '/gallery',
		name: 'gallery',
		component: GalleryView,
	},
	{
		path: '/gallery/:name',
		name: 'galleryName',
		component: FriendCollectionView,
		props: true,
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

export default router;
